<template>
    <div class="image-grid" v-if="!isMobile">
      <!-- 第一行 -->
      <div class="grid-row" v-if="chipList[1]">
        <ImageTextBlock
          v-if="chipList[1].left"
          :imageUrl="getImageUrl(chipList[1].left)"
          :title="chipList[1].left.pic_title"
          :content="chipList[1].left.pic_content"
          :url="chipList[1].left.href"
          :alt="chipList[1].left.pc_pic_alt"
        />
        <ImageTextBlock
          v-if="chipList[1].right"
          :imageUrl="getImageUrl(chipList[1].right)"
          :title="chipList[1].right.pic_title"
          :content="chipList[1].right.pic_content"
          :url="chipList[1].right.href"
          :alt="chipList[1].right.pc_pic_alt"
        />
      </div>
  
      <!-- 第二行 -->
      <div class="grid-row" v-if="chipList[2]">
        <ImageTextBlock
          v-if="chipList[2].left"
          :url="chipList[2].left.href"
          class="img-pc"
          :imageUrl="chipList[2].left.pc_pic"
          :title="chipList[2].left.pic_title"
          :content="chipList[2].left.pic_content"
          :alt="chipList[2].left.pc_pic_alt"
          :isFullWidth="true"
        />
      </div>
  
      <!-- 第三行 -->
      <div class="grid-row" v-if="chipList[3]">
        <ImageTextBlock
          v-if="chipList[3].left"
          :url="chipList[3].left.href"
          :imageUrl="getImageUrl(chipList[3].left)"
          :title="chipList[3].left.pic_title"
          :content="chipList[3].left.pic_content"
          :alt="chipList[3].left.pc_pic_alt"
        />
        <ImageTextBlock
          v-if="chipList[3].right"
          :url="chipList[3].right.href"
          :imageUrl="getImageUrl(chipList[3].right)"
          :title="chipList[3].right.pic_title"
          :content="chipList[3].right.pic_content"
          :alt="chipList[3].right.pc_pic_alt"
        />
      </div>
  
      <!-- 第四行 -->
      <div class="grid-row" v-if="chipList[4]">
        <ImageTextBlock
          v-if="chipList[4].left"
          :url="chipList[4].left.href"
          :imageUrl="getImageUrl(chipList[4].left)"
          :title="chipList[4].left.pic_title"
          :content="chipList[4].left.pic_content"
          :alt="chipList[4].left.pc_pic_alt"
        />
        <ImageTextBlock
          v-if="chipList[4].right"
          :url="chipList[4].right.href"
          :imageUrl="getImageUrl(chipList[4].right)"
          :title="chipList[4].right.pic_title"
          :content="chipList[4].right.pic_content"
          :alt="chipList[4].right.pc_pic_alt" 
        />
      </div>
    </div>
    <div class="image-grid-phone" v-if="isMobile">
      <!-- 第一行 -->
      <div class="grid-row" v-if="chipList[1]">
        <ImageTextBlockPhone
          v-if="chipList[1].left"
          :imageUrl="getImageUrl(chipList[1].left)"
          :title="chipList[1].left.pic_title"
          :content="chipList[1].left.pic_content"
          :url="chipList[1].left.href"  
          :alt="chipList[1].left.mobile_pic_alt"
        />
        <ImageTextBlockPhone
          v-if="chipList[1].right"
          :imageUrl="getImageUrl(chipList[1].right)"
          :title="chipList[1].right.pic_title"
          :content="chipList[1].right.pic_content"
          :url="chipList[1].right.href"
          :alt="chipList[1].right.mobile_pic_alt"
        />
      </div>
  
      <!-- 第二行 -->
      <div class="grid-row" v-if="chipList[2]">
        <ImageTextBlockPhone
          v-if="chipList[2].left"
          :url="chipList[2].left.href"
          class="img-phone"
          :imageUrl="chipList[2].left.mobile_pic"
          :title="chipList[2].left.pic_title"
          :content="chipList[2].left.pic_content"
          :alt="chipList[2].left.mobile_pic_alt"
        />
      </div>
  
      <!-- 第三行 -->
      <div class="grid-row" v-if="chipList[3]">
        <ImageTextBlockPhone
          v-if="chipList[3].left"
          :url="chipList[3].left.href"
          :imageUrl="getImageUrl(chipList[3].left)"
          :title="chipList[3].left.pic_title"
          :content="chipList[3].left.pic_content"
          :alt="chipList[3].left.mobile_pic_alt"
        />
        <ImageTextBlockPhone
          v-if="chipList[3].right"
          :url="chipList[3].right.href"
          :imageUrl="getImageUrl(chipList[3].right)"
          :title="chipList[3].right.pic_title"
          :content="chipList[3].right.pic_content"
          :alt="chipList[3].right.mobile_pic_alt"
        />
      </div>
  
      <!-- 第四行 -->
      <div class="grid-row" v-if="chipList[4]">
        <ImageTextBlockPhone
          v-if="chipList[4].left"
          :url="chipList[4].left.href"
          :imageUrl="getImageUrl(chipList[4].left)"
          :title="chipList[4].left.pic_title"
          :content="chipList[4].left.pic_content"
          :alt="chipList[4].left.mobile_pic_alt" 
        />
        <ImageTextBlockPhone
          v-if="chipList[4].right"
          :url="chipList[4].right.href"
          :imageUrl="getImageUrl(chipList[4].right)"
          :title="chipList[4].right.pic_title"
          :content="chipList[4].right.pic_content"
          :alt="chipList[4].right.mobile_pic_alt"
        />
      </div>
    </div>
  </template>
  
  <script>
  import ImageTextBlock from '@/components/common/ImageTextBlock.vue'
  import ImageTextBlockPhone from '@/components/common/ImageTextBlockPhone.vue'
  import { homeApi } from '@/api/home'
  import { onMounted } from 'vue';
  export default {
    components: {
    ImageTextBlock,
    ImageTextBlockPhone
  },
  data() {
    return {
      chipList: [], // 用于存储从 getChipList 接口获取的数据
      images: [], // 用于存储图片数据
      scrollPositions: {} ,
      isMobile: false,
    };
  },
  async mounted() {
    this.checkMobile();
    await this.fetchChipList(); // 调用获取 chip 列表的方法
    this.cacheScrollPositions();
  },
  methods: {
    checkMobile() {
          this.isMobile = window.innerWidth <= 768;
        },
    cacheScrollPositions() {
          const newFeaturesElement = document.getElementById('new_features');
          const applicationScenariosElement = document.getElementById('application_scenarios');

          if (newFeaturesElement) {
            const rect = newFeaturesElement.getBoundingClientRect();
            this.scrollPositions.newFeaturesTop = rect.top + window.scrollY;
          }

          if (applicationScenariosElement) {
            const rect = applicationScenariosElement.getBoundingClientRect();
            this.scrollPositions.applicationScenariosTop = rect.top + window.scrollY;
          }

          // 将位置存入缓存（例如，localStorage）
          localStorage.setItem('scrollPositions', JSON.stringify(this.scrollPositions));
        },
    async fetchChipList() {
      try {
        const response = await homeApi.getChipList(); // 调用 getChipList 接口
        this.chipList = response.data; // 假设返回的数据结构中包含 chip 列表
      } catch (error) {
        console.error('Error fetching chip list:', error);
      }
    },
    getImageUrl(chip) {
      // 根据屏幕宽度选择合适的图片 URL
      return window.innerWidth <= 768 ? chip.mobile_pic : chip.pc_pic;
    },
    // 点击事件处理函数
    handleClick(url){
      if (url!='') {
        window.location.href = url;
      } else {
        console.log('只做展示'); // 可选：记录警告
      }
    }
}
}
  </script>
  
  <style scoped>
  .image-grid {
    width: 100%;
    margin-bottom: 50px;
  }
  
  .grid-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin:0 5px;
  
  }
  
  .grid-row > * {
    flex: 1 1 calc(50% - 40px); /* 每个块占据50%的宽度，减去间隙 */
    box-sizing: border-box;
    margin: 5px; /* 每个块的白色间距 */
    overflow: hidden;
  }
  
  @media screen and (max-width: 768px) {
    .grid-row {
    flex-direction: column; /* 在移动端垂直排列 */
  }
  .grid-row > * {
    flex: 1 1 100%; /* 在移动端每个块占据100%的宽度 */
    margin: 0 ; /* 垂直间距 */
  }
  }
  
@media screen and (max-width: 768px) {
  .image-grid-phone{
    margin-bottom: 40px;
  }
}
  </style>